import React, { useEffect, useState } from 'react';
import {useSalesImportantLinks} from '../../queries/importantLinks';
import InfinitProgressBar from '../InfiniteProgressBar';
import { saveAs } from "file-saver";

function ImportantSalesLinks({classes}) {
    const saveFile = (url) => {
        saveAs(
            process.env.REACT_APP_BASE_URL + url
        );
      }
      const buttonStyle = {
        height: '35px',
        padding: '1%',
        borderBottom: ' 1px solid gray',
       
        color: 'black',
        margin: '2%',
        cursor:"pointer"
    }

    const [ImportantLinks, setImportantLinks] = useState([]);

   

    const {error, loading, data} = useSalesImportantLinks();
    
    if(loading) return <InfinitProgressBar/>
    if(error) return <div>error!</div>


    return (
        <>
        <div style={{backgroundColor: 'red', color:'white', height: '35px',  padding: '1%', borderTopLeftRadius: '6px', borderTopRightRadius: '6px'}}>لیست فرم های مهم جهت دانلود</div>
        <ul>
        {
            data.saleDownloadLink.map(f=>(
                
                <li key={f.contentItemId}  >
                    <div style={buttonStyle} onClick={()=>saveFile(f.fileToDownload.urls[0])}>{f.displayText}</div>
                </li>
            ))
        }
        </ul>        
        </>
        
    );
}

export default ImportantSalesLinks;
